<template>
  <div :class="['select-container', { small: tamanho === 'pequeno' }]">
    <select v-model="itemEscolhido" @change="$emit('change', itemEscolhido)" :class="[
      'select-item',
      {
        selecionado: itemEscolhido !== '' && itemEscolhido !== null,
        small: tamanho === 'pequeno',
        uppercase: uppercase,
      },
    ]">
      <option value="">{{ uppercase ? msgTodos.toUpperCase() : msgTodos }}</option>
      <option v-for="item in items" :key="item.id !== undefined ? item.id : (item.value ?? item.nome)"
        :value="item.id !== undefined ? item.id : item.value">
        {{ uppercase ? (item.label || item.nome || item.titulo || '').toUpperCase() : (item.label || formatarEnum(item.nome || item.titulo)) }}
      </option>
    </select>
    <img src="@/assets/icons/arrow_down.svg" alt="" class="icone-filtro" />
  </div>
</template>

<script setup>
import { formatarEnum } from "@/utils/FormatarEntradas";

defineProps({
  items: {
    type: Array,
    required: true,
  },
  msgTodos: {
    type: String,
    default: "Todos",
  },
  tamanho: {
    type: String,
    default: "maximo",
  },
  uppercase: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["change"]);

const itemEscolhido = defineModel({ default: "" });
</script>

<style scoped>
.select-container {
  position: relative;
  width: 100%;
}

.select-container.small {
  width: 250px;
  max-width: 250px;
}

.icone-filtro {
  position: absolute;
  top: 50%;
  right: 0.75rem;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  pointer-events: none;
}

.select-item {
  width: 100%;
  height: 39px;
  padding: 0 2.5rem 0 1rem;
  border: 1px solid var(--roxo-primario) !important;
  border-radius: 5px;
  font-size: 0.85rem;
  color: var(--preto);
  background-color: var(--branco);
  appearance: none;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.select-item.small {
  width: 100%;
  max-width: 250px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.select-item:focus {
  box-shadow: 0 0 0 3px hsla(258, 53%, 28%, 0.15);
}

.select-item.selecionado {
  width: 100%;
  height: 39px;
  padding: 0 2.5rem 0 1rem;
  border: 1px solid var(--roxo-primario) !important;
  border-radius: 5px;
  font-size: 0.85rem;
  color: var(--preto);
  background-color: var(--branco);
  appearance: none;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.select-item.uppercase {
  text-transform: uppercase;
}
</style>
